var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEc = function SvgEc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9794a6aa-c28d-49d6-9fb9-945975fb1486a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0fbe359a-7af3-42e6-abbe-8a3ae3235ad3b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#0fbe359a-7af3-42e6-abbe-8a3ae3235ad3b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004BA5",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F01616",
    fillRule: "evenodd",
    d: "M0 11h21v4H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF00",
    fillRule: "evenodd",
    d: "M0 0h21v8H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D2620",
    fillRule: "evenodd",
    d: "M6 4h3l1.5 1L12 4h3l-3 1-1 1h-1L9 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07A7D3",
    d: "M10.5 10c.828 0 1.5-.895 1.5-2s-.672-2-1.5-2S9 6.895 9 8s.672 2 1.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDF00",
    fillRule: "evenodd",
    d: "M8 7v2l2 1h1l2-1V7l1 2-1 1-2 1h-1l-2-1-1-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9794a6aa-c28d-49d6-9fb9-945975fb1486a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgEc;